import { render, staticRenderFns } from "./DrillAiMath.vue?vue&type=template&id=72351190&scoped=true&lang=pug&"
import script from "./DrillAiMath.vue?vue&type=script&lang=ts&"
export * from "./DrillAiMath.vue?vue&type=script&lang=ts&"
import style0 from "./DrillAiMath.vue?vue&type=style&index=0&id=72351190&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72351190",
  null
  
)

export default component.exports